<div class="content-inner form-buttons">  
    <button *ngIf="!currentPage.nextPage" class="primary" (click)="done()" [disabled]="!isFormValid">Done</button> 
    <button *ngIf="currentPage.nextPage" class="primary" (click)="next()" [disabled]="!isFormValid">Next</button>
    <button *ngIf="currentPage.previousPage" class="cancel" (click)="previous()">Back</button>
    <button *ngIf="currentPage.nextPage && currentPage.isSkippable" class="cancel" (click)="skip()">Skip</button>
</div>
